import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useBrand } from '@/hooks/use-brand';
import { Link } from '@inertiajs/react';
import { Map as MapIcon, Rss } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DiscoveryBarProps {
  gender: string;
  onMapOpen: () => void;
}

export function DiscoveryBar({ gender, onMapOpen }: DiscoveryBarProps) {
  const { t } = useTranslation('common');
  const brand = useBrand();

  const tabs = [
    { key: 'female', label: t('nav.female'), href: '/' },
    { key: 'male', label: t('nav.male'), href: '/male' },
    { key: 'trans', label: t('nav.trans'), href: '/trans' },
  ];

  return (
    <div className="sticky top-[57px] z-40 border-b border-border bg-background">
      <div className="container mx-auto px-4">
        <div className="flex h-11 items-center justify-between gap-3">
          {/* Gender pill toggle — hidden when brand has a gender focus */}
          {!brand.gender_focus && (
            <div className="flex items-center rounded-full bg-muted p-0.5">
              {tabs.map((tab) => (
                <Button
                  key={tab.key}
                  asChild
                  variant={gender === tab.key ? 'secondary' : 'ghost'}
                  size="pill"
                  className="rounded-full"
                >
                  <Link href={tab.href}>
                    {tab.label}
                  </Link>
                </Button>
              ))}
            </div>
          )}

          {/* Right side — Feed link + Map button */}
          <div className="ml-auto flex items-center gap-1">
            <Button
              asChild
              variant="ghost"
              size="pill"
              className="gap-1.5"
            >
              <Link href="/feed">
                <Rss className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">{t('discovery.feed')}</span>
              </Link>
            </Button>
            <Button
              onClick={onMapOpen}
              variant="ghost"
              size="pill"
              className="gap-1.5"
            >
              <MapIcon className="h-3.5 w-3.5" />
              <span className="hidden sm:inline">{t('discovery.map')}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
